import { useState, useEffect} from 'react';
import {
  LazyMesConges,
  LazyCongesRH,
  LazyMesDocs,
  LazyMaVisite,
  LazyMonEntretienV2,
  LazyCartePro,
  LazyMedecine,
  LazyMonProfil,
  LazyMaBaseDoc,
  LazyMonPlanning,
  LazyPersonnel,
  LazyEntretiensRH,
  LazyGestionAcces,
  LazyReunions,
  LazyPlanningHoraires,
  LazyEspaceSections,
  LazyRUP,
  LazyParametres,
  LazyCommunication,
  LazyAdherents,
  LazyComptabilite,
  LazyFormations,
  LazyBenevoles,
  LazyRemunerations,
  LazyAbsencesNP,
  LazyPlanningUnifie,
  LazyMonitoring,
  LazyGestionSharePoint,
  LazyBaseDocumentaire,
  LazyOnboarding,
  LazyObjectifs,
  LazyWorkflows,
  LazyMessagerie,
  LazyVariablesPaie,
  LazyPlanFormation,
  LazyIndicateursRH,
  LazyBilanSocial,
  LazyExportComplet,
  LazyImportEtendu,
  LazyNotesRH,
  LazyAnniversaires,
  LazyAffichageReglementaire,
  LazyDUERP,
  LazyAlertesConfig,
  LazyInfosAssociation,
  LazyHistoriqueModifs,
  LazyTestEmail,
  LazyModelsEmails,
  LazyEffectifsClub,
  LazyPurgeData,
  LazyGestionContrats,
  LazyPlanning,
  LazyOrganigramme,
  LazyGED,
} from './app.lazy';
import { CSE } from './components/modules/CSE';
import { ONGLETS_CATALOGUE, HUBS_LISTE } from './app.catalogue';

function getTabsForHub(hubKey, hubConfig) {
  // hubConfig = { [tabKey]: { hub, ordre } } — surcharges persistées
  return ONGLETS_CATALOGUE
    .filter(t => {
      if (t.horsHub) return false; // toujours standalone, jamais dans un hub
      const overrideHub = hubConfig?.[t.key]?.hub;
      return (overrideHub || t.hub) === hubKey;
    })
    .sort((a, b) => {
      const oa = hubConfig?.[a.key]?.ordre ?? 999;
      const ob = hubConfig?.[b.key]?.ordre ?? 999;
      return oa - ob;
    });
}

// ═══════════════════════════════════════════════════════════════════════════════
// HUBS — Composants de fusion (onglets dynamiques)
// ═══════════════════════════════════════════════════════════════════════════════

function TabBar({ tabs, active, setActive, hashPrefix }) {
  return (
    <div style={{ display:'flex', gap:4, flexWrap:'wrap', marginBottom:20, borderBottom:'2px solid var(--border)', paddingBottom:8 }}>
      {tabs.map(t => {
        const hash = hashPrefix ? '#' + hashPrefix + ':' + encodeURIComponent(t.key) : '#';
        return (
          <a key={t.key}
            href={hash}
            onClick={e => { e.preventDefault(); setActive(t.key); }}
            style={{ padding:'7px 14px', borderRadius:'8px 8px 0 0', border:'none', cursor:'pointer',
              fontFamily:'inherit', fontWeight:700, fontSize:'0.82rem', textDecoration:'none',
              background: active===t.key ? 'var(--bleu)' : 'var(--bg2)',
              color: active===t.key ? '#fff' : 'var(--text)',
              borderBottom: active===t.key ? '2px solid var(--bleu)' : '2px solid transparent',
              marginBottom: -10, display:'inline-block',
            }}>
            {t.icon} {t.label}
          </a>
        );
      })}
    </div>
  );
}

// Rendu dynamique d'un onglet selon sa clé
function renderOnglet(key, props) {
  // eslint-disable-next-line no-unused-vars
  const { staff, setStaff, users, setUsers, postes, setPostes, docs, setDocs,
    conges, setConges, soldes, setSoldes, medecine, setMedecine,
    // eslint-disable-next-line no-unused-vars
    entretiens, setEntretiens, formations, setFormations, planFormation, setPlanFormation,
    remunerations, setRemunerations, variables, setVariables,
    absencesNP, setAbsencesNP, objectifs, setObjectifs,
    onboarding, setOnboarding, contratsGen, planningH, setPlanningH,
    notesRH, setNotesRH, orgaConfig, setOrgaConfig, profils, setProfils,
    events, setEvents, presences, setPresences,
    baseDocs, setBaseDocs, annonces, setAnnonces, messages, setMessages,
    messagerie, setMessagerie, commPerms, setCommPerms,
    workflows, setWorkflows, demandesWF, setDemandesWF,
    affichage, setAffichage, reunions, setReunions,
    benevoles, setBenevoles, adherents, setAdherents,
    adherentsConfig, setAdherentsConfig, accesCoordAdh, setAccesCoordAdh,
    rup, setRup, modeles, setModeles, contratsG, setContratsG, infosAsso,
    user, isAdmin, isRH, isManager,
    accesCoord, myStaffId, myUserId, paramsAPI, paramsRH,
    audit, setAudit, connexions,
    modulesDesac, setModulesDesac, chatbotConfig, setChatbotConfig,
    setParamsAPI, setParamsRH, alertesConfig, setAlertesConfig,
    setInfosAsso, setStaffAdmin, setDocsAdmin, setCongesAdmin,
    setSoldesAdmin, setPlanningHAdmin, setMedecineAdmin,
    hubConfig, setHubConfig,
    getAccessToken, prolongerSession,
    navigate,
    configKpi, setConfigKpi,
  } = props;

  switch(key) {
    // ── Personnel
    case 'fiches':        return <LazyPersonnel staff={staff} setStaff={setStaff} postes={postes} setPostes={setPostes} profils={profils} setProfils={setProfils} docs={docs} setDocs={setDocs} medecine={medecine} conges={conges} entretiens={entretiens} formations={formations} remunerations={remunerations} absencesNP={absencesNP} onboarding={onboarding} users={users} setUsers={setUsers} setOnboarding={setOnboarding} rup={rup} setRup={setRup} soldes={soldes} setSoldes={setSoldes} paramsAPI={paramsAPI||{}} infosAsso={{}} modulesDesac={{}} sectionPerms={{}} setSectionPerms={()=>{}} setRemunerations={setRemunerations}/>;
    case 'organigramme':  return <LazyOrganigramme staff={staff} isRH={isRH} orgaConfig={orgaConfig} user={user} myStaffId={myStaffId} myUserId={myUserId} accesCoord={accesCoord} profils={profils}/>;
    case 'effectifs':     return <LazyEffectifsClub isAdmin={isAdmin} isRH={isRH}/>;
    case 'onboarding':    return <LazyOnboarding onboarding={onboarding} setOnboarding={setOnboarding} staff={staff}/>;
    case 'notes':         return <LazyNotesRH notes={notesRH} setNotes={setNotesRH} staff={staff} user={user} users={users}/>;
    case 'anniversaires': return <LazyAnniversaires staff={staff} contrats={contratsGen} medecine={medecine} formations={formations}/>;
    case 'paie':          return <><LazyRemunerations remunerations={remunerations} setRemunerations={setRemunerations} staff={staff}/><LazyVariablesPaie variables={variables} setVariables={setVariables} staff={staff} users={users}/></>;
    case 'formations':    return <LazyFormations staff={staff} users={users}/>; // ✅ Formations gère ses propres données
    case 'plan-formation':return <LazyPlanFormation planFormation={planFormation} setPlanFormation={setPlanFormation} staff={staff} formations={formations}/>;
    // ── Planning
    case 'unifie':        return <LazyPlanningUnifie events={events} setEvents={setEvents} conges={conges} entretiens={entretiens} medecine={medecine} formations={formations} planningH={planningH} user={user} users={users} staff={staff} isRH={isRH} isManager={isManager} isAdmin={isAdmin}/>;
    case 'evenements':    return <LazyPlanning events={events} setEvents={setEvents} user={user} users={users} staff={staff}/>;
    case 'horaires':      return <LazyPlanningHoraires planningH={planningH} setPlanningH={setPlanningH} staff={staff} user={user} users={users} presences={presences} setPresences={setPresences} isRH={isRH} managerMode={isManager && !isRH}/>;
    // ── Vie au travail
    case 'conges':        return <LazyCongesRH conges={conges} setConges={setConges} soldes={soldes} setSoldes={setSoldes} staff={staff} users={users} paramsRH={paramsRH} paramsAPI={paramsAPI}/>;
    case 'absences':      return <LazyAbsencesNP absences={absencesNP} setAbsences={setAbsencesNP} staff={staff}/>;
    case 'medecine':      return <LazyMedecine medecine={medecine} setMedecine={setMedecine} staff={staff}/>;
    case 'entretiens':    return <LazyEntretiensRH entretiens={entretiens} setEntretiens={setEntretiens} staff={staff} users={users} user={user} paramsAPI={paramsAPI} formations={formations}/>;
    case 'objectifs':     return <LazyObjectifs objectifs={objectifs} setObjectifs={setObjectifs} staff={staff} user={user} entretiens={entretiens} users={users}/>;
    // ── Contrats
    case 'contrats':      return <LazyGestionContrats paramsAPI={paramsAPI} staff={staff} profils={profils} users={users} modeles={modeles} setModeles={setModeles} contratsGen={contratsG} setContratsGen={setContratsG} infosAsso={infosAsso}/>;
    case 'rup':           return <LazyRUP rup={rup} setRup={setRup} staff={staff} isAdmin={isAdmin} profils={profils} infosAsso={infosAsso}/>;
    case 'cartepro':      return <LazyCartePro docs={docs} setDocs={setDocs} staff={staff} users={users} paramsAPI={paramsAPI} infosAsso={infosAsso}/>;
    case 'cse':           return <CSE staff={staff} infosAsso={infosAsso} isAdmin={isAdmin} isRH={isRH} />;
    case 'duerp':         return <LazyDUERP user={user}/>;
    // ── Collaboration
    case 'reunions':      return <LazyReunions reunions={reunions} setReunions={setReunions} users={users} staff={staff} user={user} paramsAPI={paramsAPI}/>;
    case 'communication': return <LazyCommunication user={user} users={users} staff={staff} annonces={annonces} setAnnonces={setAnnonces} messages={messages} setMessages={setMessages} commPerms={commPerms} setCommPerms={setCommPerms}/>;
    case 'messagerie':    return <LazyMessagerie messages={messagerie} setMessages={setMessagerie} user={user} users={users} staff={staff}/>;
    case 'ged':           return <LazyGED user={user} users={users} staff={staff}/>;
    case 'basedocs':      return <LazyBaseDocumentaire baseDocs={baseDocs} setBaseDocs={setBaseDocs} user={user} users={users} staff={staff}/>;
    case 'workflows':     return <LazyWorkflows workflows={workflows} setWorkflows={setWorkflows} demandesWF={demandesWF} setDemandesWF={setDemandesWF} staff={staff} users={users} user={user}/>;
    case 'affichage':     return <LazyAffichageReglementaire affichage={affichage} setAffichage={setAffichage}/>;
    
    // ── Club
    case 'benevoles':     return <LazyBenevoles benevoles={benevoles} setBenevoles={setBenevoles} staff={staff} users={users}/>;
    case 'adherents':     return <LazyAdherents adherents={adherents} setAdherents={setAdherents} adherentsConfig={adherentsConfig} setAdherentsConfig={setAdherentsConfig} users={users} staff={staff} isAdmin={isAdmin} currentUserId={user?.id} paramsAPI={paramsAPI}/>;
    case 'sections':      return <LazyEspaceSections user={user} staff={staff} isRH={isRH} isAdmin={isAdmin} events={events} setEvents={setEvents} adherents={adherents} adherentsConfig={adherentsConfig} setAdherents={setAdherents} accesCoordAdh={accesCoordAdh} setAccesCoordAdh={setAccesCoordAdh}/>;
    case 'comptabilite':  return <LazyComptabilite user={user} isAdmin={isAdmin} isRH={isRH} users={users}/>;
    // ── Reporting
    case 'kpis':          return <LazyIndicateursRH staff={staff} conges={conges} planningH={planningH} medecine={medecine} entretiens={entretiens} soldes={soldes} formations={formations} rup={rup} onNavigate={navigate} configActifsExt={configKpi} setConfigActifsExt={setConfigKpi}/>;
    case 'bilan':         return <LazyBilanSocial staff={staff} conges={conges} planningH={planningH} docs={docs} medecine={medecine} entretiens={entretiens} remunerations={remunerations} formations={formations} absencesNP={absencesNP}/>;
    case 'export':        return <LazyExportComplet staff={staff} conges={conges} soldes={soldes} docs={docs} medecine={medecine} entretiens={entretiens} planningH={planningH} baseDocs={baseDocs} events={events} remunerations={remunerations} formations={formations} absencesNP={absencesNP} reunions={reunions} onboarding={onboarding} user={user} audit={audit} setAudit={setAudit}/>;
    // ── Admin
    case 'parametres':    return <LazyParametres user={user} users={users} staff={staff} modulesDesac={modulesDesac} setModulesDesac={setModulesDesac} chatbotConfig={chatbotConfig} setChatbotConfig={setChatbotConfig} paramsAPI={paramsAPI} setParamsAPI={setParamsAPI} paramsRH={paramsRH} setParamsRH={setParamsRH}/>;
    case 'acces':         return <LazyGestionAcces users={users} setUsers={setUsers} staff={staff} postes={postes} setPostes={setPostes} orgaConfig={orgaConfig} setOrgaConfig={setOrgaConfig} paramsAPI={paramsAPI} infosAsso={infosAsso} user={user} getAccessToken={getAccessToken} prolongerSession={prolongerSession}/>;
    case 'infos-asso':    return <LazyInfosAssociation infosAsso={infosAsso} setInfosAsso={setInfosAsso}/>;
    case 'alertes':       return <LazyAlertesConfig alertesConfig={alertesConfig} setAlertesConfig={setAlertesConfig} users={users} staff={staff}/>;
    case 'import':        return <LazyImportEtendu staff={staff} setStaff={setStaffAdmin} postes={postes} docs={docs} setDocs={setDocsAdmin} conges={conges} setConges={setCongesAdmin} soldes={soldes} setSoldes={setSoldesAdmin} planningH={planningH} setPlanningH={setPlanningHAdmin} medecine={medecine} setMedecine={setMedecineAdmin}/>;
    case 'historique':    return <LazyHistoriqueModifs connexions={connexions} audit={audit} user={user}/>;
    case 'test-email':    return <LazyTestEmail users={users} staff={staff}/>;
    case 'organisation':  return <OrganisationHubs hubConfig={hubConfig} setHubConfig={setHubConfig}/>;
    case 'purge':         return <LazyPurgeData isAdmin={isAdmin}/>;
    case 'modeles-emails':return <LazyModelsEmails/>;
    case 'monitoring':    return <LazyMonitoring isAdmin={isAdmin} />;
    case 'sharepoint':    return <LazyGestionSharePoint user={user} />;
    default: return <div style={{padding:20,color:'var(--muted)'}}>Onglet inconnu : {key}</div>;
  }
}

// ── Onglet Organisation des hubs (drag-and-drop) ──────────────────────────────
function OrganisationHubs({ hubConfig, setHubConfig }) {
  const [dragKey, setDragKey] = useState(null);
  const [dragOver, setDragOver] = useState(null);

  // Construire la vue actuelle : hub → [onglets triés]
  const hubsView = HUBS_LISTE.map(h => ({
    ...h,
    tabs: getTabsForHub(h.key, hubConfig),
  }));

  const moveToHub = (tabKey, newHub) => {
    setHubConfig(prev => {
      const next = { ...(prev||{}) };
      // Calculer le nouvel ordre : fin de la liste du hub cible
      const tabsInTarget = ONGLETS_CATALOGUE.filter(t => {
        const oh = next[t.key]?.hub || t.hub;
        return oh === newHub;
      });
      next[tabKey] = { hub: newHub, ordre: tabsInTarget.length * 10 + 10 };
      return next;
    });
  };

  const reorder = (tabKey, direction) => {
    setHubConfig(prev => {
      const next = { ...(prev||{}) };
      const currentHub = next[tabKey]?.hub || ONGLETS_CATALOGUE.find(t=>t.key===tabKey)?.hub;
      const tabsInHub = getTabsForHub(currentHub, next);
      const idx = tabsInHub.findIndex(t => t.key === tabKey);
      const newIdx = idx + direction;
      if (newIdx < 0 || newIdx >= tabsInHub.length) return prev;
      // Échanger les ordres
      const a = tabsInHub[idx];
      const b = tabsInHub[newIdx];
      const oA = next[a.key]?.ordre ?? idx * 10;
      const oB = next[b.key]?.ordre ?? newIdx * 10;
      next[a.key] = { ...(next[a.key]||{}), hub: currentHub, ordre: oB };
      next[b.key] = { ...(next[b.key]||{}), hub: currentHub, ordre: oA };
      return next;
    });
  };

  const reset = () => setHubConfig({});

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:'1.1rem', fontWeight:800, color:'var(--bleu)', marginBottom:4 }}>🗂 Organisation des modules</h2>
          <p style={{ fontSize:'0.8rem', color:'var(--muted)' }}>Déplacez les onglets entre les hubs ou réordonnez-les. Les onglets 🔒 sont fixes. Les onglets 🏛️ sont toujours standalone.</p>
        </div>
        <button className="btn btn-secondary" onClick={reset} style={{ fontSize:'0.78rem' }}>↩ Rétablir les défauts</button>
      </div>

      {/* ── Zone standalone (hors hub) ── */}
      {(() => {
        const standalone = ONGLETS_CATALOGUE.filter(t => t.horsHub);
        if (!standalone.length) return null;
        return (
          <div style={{ marginBottom:20, background:'rgba(0,48,135,0.04)', border:'2px solid rgba(0,48,135,0.15)', borderRadius:10, padding:'12px 14px' }}>
            <div style={{ fontWeight:800, fontSize:'0.85rem', color:'var(--bleu)', marginBottom:10 }}>🏛️ Modules standalone — toujours visibles hors hub</div>
            {standalone.map(t => (
              <div key={t.key} style={{ display:'flex', alignItems:'center', gap:8, padding:'7px 10px', marginBottom:4, borderRadius:7, background:'var(--bg)', border:'1px solid var(--border)', cursor:'default' }}>
                <span style={{ fontSize:'0.9rem' }}>{t.icon}</span>
                <span style={{ flex:1, fontSize:'0.8rem', fontWeight:600 }}>{t.label}</span>
                <span style={{ fontSize:'0.68rem', color:'var(--muted)' }}>🔒 standalone</span>
              </div>
            ))}
          </div>
        );
      })()}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))', gap:16 }}>
        {hubsView.map(hub => (
          <div key={hub.key}
            onDragOver={e => { e.preventDefault(); setDragOver(hub.key); }}
            onDragLeave={() => setDragOver(null)}
            onDrop={e => {
              e.preventDefault();
              if (dragKey) { moveToHub(dragKey, hub.key); setDragKey(null); setDragOver(null); }
            }}
            style={{ background:'var(--bg2)', border:`2px solid ${dragOver===hub.key?'var(--cyan)':'var(--border)'}`, borderRadius:10, padding:'12px 14px', transition:'border-color 0.15s' }}>
            <div style={{ fontWeight:800, fontSize:'0.85rem', color:'var(--bleu)', marginBottom:10 }}>{hub.label}</div>
            {hub.tabs.length === 0
              ? <div style={{ fontSize:'0.75rem', color:'var(--muted)', fontStyle:'italic', padding:'8px 0' }}>Aucun onglet — déposez-en un ici</div>
              : hub.tabs.map((t, idx) => (
                <div key={t.key}
                  draggable={!t.fixe}
                  onDragStart={() => !t.fixe && setDragKey(t.key)}
                  onDragEnd={() => setDragKey(null)}
                  style={{
                    display:'flex', alignItems:'center', gap:8, padding:'7px 10px',
                    marginBottom:4, borderRadius:7, background:'var(--bg)',
                    border:'1px solid var(--border)',
                    opacity: dragKey===t.key ? 0.4 : 1,
                    cursor: t.fixe ? 'default' : 'grab',
                    transition:'opacity 0.12s',
                  }}>
                  <span style={{ fontSize:'0.9rem' }}>{t.icon}</span>
                  <span style={{ flex:1, fontSize:'0.8rem', fontWeight:600 }}>{t.label}</span>
                  {t.fixe
                    ? <span style={{ fontSize:'0.68rem', color:'var(--muted)' }}>🔒</span>
                    : <>
                        <button onClick={() => reorder(t.key, -1)} disabled={idx===0}
                          style={{ border:'none', background:'none', cursor:'pointer', color:'var(--muted)', fontSize:'0.75rem', padding:'0 3px', opacity:idx===0?0.3:1 }}>▲</button>
                        <button onClick={() => reorder(t.key, 1)} disabled={idx===hub.tabs.length-1}
                          style={{ border:'none', background:'none', cursor:'pointer', color:'var(--muted)', fontSize:'0.75rem', padding:'0 3px', opacity:idx===hub.tabs.length-1?0.3:1 }}>▼</button>
                        <select value={hub.key} onChange={e => moveToHub(t.key, e.target.value)}
                          style={{ fontSize:'0.68rem', border:'1px solid var(--border)', borderRadius:5, padding:'2px 4px', background:'var(--bg)', color:'var(--text)', cursor:'pointer' }}>
                          {HUBS_LISTE.map(h => <option key={h.key} value={h.key}>{h.label}</option>)}
                        </select>
                      </>
                  }
                </div>
              ))
            }
          </div>
        ))}
      </div>
    </div>
  );
}

// Hub générique — lit la config et rend les onglets dynamiquement
function HubDynamique({ hubKey, hubConfig, allProps, initialTab, pageSlugs }) {
  const tabs = getTabsForHub(hubKey, hubConfig);

  const [tab, setTab] = useState(() => {
    if (initialTab && tabs.find(t => t.key === initialTab)) return initialTab;
    return tabs[0]?.key || '';
  });

  // Écouter les changements de hash pour gérer la navigation depuis les notifications
  useEffect(() => {
    const handleHash = () => {
      const currentHash = window.location.hash.replace('#', '');
      const prefix = 'hub-' + hubKey + ':';
      const hashPart = currentHash.split('/').find(p => p.startsWith(prefix));
      if (hashPart) {
        const tabFromHash = decodeURIComponent(hashPart.split(':')[1]);
        if (tabs.find(t => t.key === tabFromHash)) setTab(tabFromHash);
      }
    };
    handleHash(); // lire au montage
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Si l'onglet actif n'existe plus dans ce hub, revenir au premier
  const activeTab = tabs.find(t => t.key === tab) ? tab : tabs[0]?.key || '';

  // Mettre à jour l'URL quand l'onglet change
  const handleSetTab = (key) => {
    setTab(key);
    // Mettre à jour le hash avec l'onglet hub actif
    const hash = window.location.hash.replace('#', '');
    const prefix = 'hub-' + hubKey + ':';
    const parts = hash.split('/').filter(p => p && !p.startsWith(prefix));
    parts.push(prefix + key);
    window.location.hash = parts.join('/');
    // Ne pas changer le pathname — rester sur l'URL du hub
    // pour que F5 restaure correctement via le hash
  };

  if (tabs.length === 0) return (
    <div style={{ padding:'40px', textAlign:'center', color:'var(--muted)' }}>
      Aucun onglet dans ce hub. Allez dans Administration → Organisation des modules.
    </div>
  );

  return (
    <div style={{ padding:'24px 28px', maxWidth:1200, margin:'0 auto' }}>
      <TabBar tabs={tabs} active={activeTab} setActive={handleSetTab} />
      {renderOnglet(activeTab, allProps)}
    </div>
  );
}

function HubMonEspace({ user, conges, setConges, soldes, docs, medecine, entretiens, setEntretiens, formations, planningH, presences, setPresences, staff, profils, setProfils, setStaff, users, setUsers, baseDocs, paramsAPI, infosAsso, paramsRH, isManager, isRH }) {
  const [tab, setTab] = useState('conges');
  const TABS = [
    { key:'conges',   icon:'🏖️', label:'Mes congés' },
    { key:'planning', icon:'🗒️', label:'Mon planning' },
    { key:'docs',     icon:'📄', label:'Mes documents' },
    { key:'visite',   icon:'🩺', label:'Ma visite médicale' },
    { key:'entretien',icon:'🗣️', label:'Mon entretien' },
    { key:'ressources',icon:'📚',label:'Ressources' },
    { key:'profil',   icon:'👤', label:'Mon profil' },
  ];
  return (
    <div style={{ padding:'24px 28px', maxWidth:1200, margin:'0 auto' }}>
      <TabBar tabs={TABS} active={tab} setActive={setTab} />
      {tab==='conges'    && <LazyMesConges user={user} conges={conges} setConges={setConges} soldes={soldes} users={users} staff={staff} paramsRH={paramsRH}/>}
      {tab==='planning'  && <LazyMonPlanning user={user} planningH={planningH} staff={staff} presences={presences} setPresences={setPresences}/>}
      {tab==='docs'      && <LazyMesDocs user={user} docs={docs} users={users} staff={staff} paramsAPI={paramsAPI} infosAsso={infosAsso}/>}
      {tab==='visite'    && <LazyMaVisite user={user} medecine={medecine}/>}
      {tab==='entretien' && <LazyMonEntretienV2 user={user} entretiens={entretiens} setEntretiens={setEntretiens}/>}
      {tab==='ressources'&& <LazyMaBaseDoc baseDocs={baseDocs} user={user}/>}
      {tab==='profil'    && <LazyMonProfil user={user} profils={profils} setProfils={setProfils} staff={staff} setStaff={setStaff} users={users} setUsers={setUsers}/>}
    </div>
  );
}


export { getTabsForHub, TabBar, renderOnglet, OrganisationHubs, HubDynamique, HubMonEspace };
